/**
 * Private Routes - Rotas do cliente (necessitam autenticação)
 */
import { Routes, Route } from 'react-router-dom';
import Layout from '../components/templates/layout/Layout';
import DashboardPage from '../pages/Dashboard';
import CollectionsPage from '../pages/Collections';
import FavoritesPage from '../pages/Favorites';
import ArticlePage from '../pages/ArticlePage';
import { TagsPage, TagsCoverPage } from '../pages/TagsPage';
import ArticlesByTagPage from '../pages/TagsPage/ArticlesByTagPage';
import { CollectionArticlesPage } from '../pages/CollectionsPage';
import ProfilePage from '../pages/ProfilePage';
import NewsletterPage from '../pages/NewsletterPage';
import NewsletterDashboard from '../pages/NewsletterDashboard';
import TemplateManager from '../pages/TemplateManager';
import ContactGroups from '../pages/ContactGroups';
import BrandManagementPage from '../pages/admin/BrandManagementPage';
import BrandSelectionPage from '../pages/BrandSelectionPage';
import BrandSettingsPage from '../pages/BrandSettingsPage';
import BriefingPage from '../pages/BriefingPage';
import ReleasesPage from '../pages/ReleasesPage';
import PRControlsPage from '../pages/PRControlsPage';
import AnalyticsPage from '../pages/AnalyticsPage';
import CardsTestingPage from '../pages/CardsTestingPage';
import ProtectedRoute from '../components/organisms/auth/ProtectedRoute';

const PrivateRoutes = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route index element={<DashboardPage />} />
                <Route path="collections" element={<CollectionsPage />} />
                <Route path="colecoes/:collectionId/artigos" element={<CollectionArticlesPage />} />
                <Route path="favorites" element={<FavoritesPage />} />
                <Route path="articles" element={<ArticlePage />} />
                <Route path="tags" element={<TagsCoverPage />} />
                <Route path="tags/:tagId/artigos" element={<ArticlesByTagPage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="newsletter" element={<NewsletterPage />} />
                <Route path="newsletter/dashboard" element={<NewsletterDashboard />} />
                <Route path="newsletter/templates" element={<TemplateManager />} />
                <Route path="newsletter/groups" element={<ContactGroups />} />

                {/* Gestão de Marcas do Usuário */}
                <Route path="brands" element={<BrandManagementPage />} />
                <Route path="brand-selection" element={<BrandSelectionPage />} />
                <Route path="brand-settings" element={<BrandSettingsPage />} />
                <Route path="briefing" element={<BriefingPage />} />
                <Route path="releases" element={<ReleasesPage />} />
                <Route path="pr-controls" element={<PRControlsPage />} />
                <Route path="analytics" element={<AnalyticsPage />} />
                <Route
                    path="cerds-testando"
                    element={
                        <ProtectedRoute requireAdminOrMensure>
                            <CardsTestingPage />
                        </ProtectedRoute>
                    }
                />
            </Route>
        </Routes>
    );
};

export default PrivateRoutes;
